import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";
import logo from "@/assets/logo.png?format=webp&w=200";
import logoFallback from "@/assets/logo.png";

const footerLinks = {
  services: [
    { name: "Monthly Bookkeeping", path: "/services" },
    { name: "Payroll Services", path: "/services" },
    { name: "Tax Returns", path: "/services" },
    { name: "CIPC Annual Returns", path: "/services" },
    { name: "International Services", path: "/international-services" },
  ],
  locations: [
    { name: "Johannesburg", path: "/bookkeeping-services-johannesburg" },
    { name: "Cape Town", path: "/bookkeeping-services-cape-town" },
    { name: "Durban", path: "/bookkeeping-services-durban" },
    { name: "Pretoria", path: "/bookkeeping-services-pretoria" },
  ],
  company: [
    { name: "About Us", path: "/about" },
    { name: "Packages & Pricing", path: "/packages" },
    { name: "Book a Call", path: "/book-a-call" },
    { name: "Contact", path: "/contact" },
  ],
  legal: [
    { name: "Privacy Policy", path: "/privacy" },
    { name: "Terms of Service", path: "/terms" },
    { name: "POPIA Compliance", path: "/privacy" },
    { name: "FAQs", path: "/services#faq" },
  ],
};

export function Footer() {
  return (
    <footer className="bg-foreground text-background">
      <div className="container mx-auto px-4 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12">
          {/* Brand Column */}
          <div className="space-y-6">
            <Link to="/" className="flex items-center gap-3">
              <picture>
                <source srcSet={logo} type="image/webp" />
                <img
                  src={logoFallback}
                  alt="Bookkeeping Services SA"
                  className="h-12 w-auto brightness-0 invert"
                  width={48}
                  height={48}
                  loading="lazy"
                  decoding="async"
                />
              </picture>
            </Link>
            <p className="text-background/70 text-sm leading-relaxed">
              Professional bookkeeping and accounting services built on trust. Serving South African businesses.
            </p>
            <div className="space-y-3 text-sm">
              <a href="mailto:info@bookkeepingservices.co.za" className="flex items-center gap-3 text-background/70 hover:text-background transition-colors">
                <Mail className="w-4 h-4" />
                info@bookkeepingservices.co.za
              </a>
              <div className="flex items-center gap-3 text-background/70">
                <MapPin className="w-4 h-4" />
                Remote across South Africa
              </div>
            </div>
          </div>

          {/* Services */}
          <div>
            <h3 className="font-heading text-lg font-semibold mb-6">Services</h3>
            <ul className="space-y-3">
              {footerLinks.services.map(link => (
                <li key={link.name}>
                  <Link to={link.path} className="text-sm text-background/70 hover:text-background transition-colors">
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Locations */}
          <div>
            <h3 className="font-heading text-lg font-semibold mb-6">Locations</h3>
            <ul className="space-y-3">
              {footerLinks.locations.map(link => (
                <li key={link.name}>
                  <Link to={link.path} className="text-sm text-background/70 hover:text-background transition-colors">
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 className="font-heading text-lg font-semibold mb-6">Company</h3>
            <ul className="space-y-3">
              {footerLinks.company.map(link => (
                <li key={link.name}>
                  <Link to={link.path} className="text-sm text-background/70 hover:text-background transition-colors">
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="font-heading text-lg font-semibold mb-6">Legal</h3>
            <ul className="space-y-3">
              {footerLinks.legal.map(link => (
                <li key={link.name}>
                  <Link to={link.path} className="text-sm text-background/70 hover:text-background transition-colors">
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-background/10 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-background/50">
            © {new Date().getFullYear()} Bookkeeping Services South Africa. All rights reserved.
          </p>
          <p className="text-xs text-background/60">Built on Trust</p>
        </div>
      </div>
    </footer>
  );
}
